import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  type?: 'left' | 'right' | 'rightCenter';
}

export const TooltipItem = styled.div<IProps>`
  ${mixin.flex({
    justify: 'space-between',
    align: 'flex-start',
  })}
  column-gap: 8px;
  position: absolute;
  top: 0;
  width: max-content;
  max-width: 260px;
  padding: 8px 10px;
  background-color: #333;
  border-radius: 4px;
  z-index: 1;
  pointer-events: auto;

  .text {
    line-height: 130%;
    text-align: left;
    font-size: 12px;
    font-weight: 400;
    color: #fff;
  }

  .btn-close {
    position: relative;
    pointer-events: auto;
    margin-top: 2.5px;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;

    &::before {
      content: '';
      position: absolute;
      background-color: transparent;
      width: 24px;
      height: 24px;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
    }

    svg {
      display: block !important;
      margin-left: 0 !important;
      width: 10px !important;
      height: 10px !important;
    }

    path {
      fill: #fff;
    }
  }

  &:after {
    content: '';
    position: absolute;
    top: -6px;
    border-style: solid;
    border-width: 0 4.5px 8px 4.5px;
    border-color: transparent transparent #333333 transparent;
  }

  ${props => {
    switch (props.type) {
      case 'left':
        return css`
          left: 0;

          &:after {
            left: 32px;
          }
        `;
      case 'right':
        return css`
          right: 0;

          &:after {
            right: 32px;
          }
        `;
      case 'rightCenter':
        return css`
          right: 0;

          &:after {
            right: -6px;
            top: 50%;
            transform: rotate(90deg) translateX(-50%);
          }
        `;
      default:
        return null;
    }
  }}

  @media ${({ theme }) => theme.media.pc} {
    max-width: 320px;
    padding: 9px 12px;
  }
`;
